import React, {useState} from 'react';
import {useAppState, MarkupRender, Modal} from "@nutastic/nutastic-react-app";
import PageHeader from "../PageHeader";
import BookSessionModal from "../BookSessionModal";

const ServicesPage = () => {
    const {
        packages,
        page: {
            image_1,
            title,
            content,
            field_1: introText,
            field_4: servicesTitle,
            field_7: servicesSubtitle,
            field_8: servicesFooter
        }
    } = useAppState();
    const componentClass = 'services-page';
    const [ showBookingModal, setShowBookingModal ] = useState(false);
    const [ showPackageModal, setShowPackageModal ] = useState(false);
    const [ selectedType, setSelectedType ] = useState(false);

    const onBookingClick = (pkg) => {
        setShowBookingModal(true);
        if(pkg) {
            setSelectedType(pkg);
        }
    }
    const onCloseClick = () => {
        setShowBookingModal(false);
        setSelectedType(false);
    }

    const renderedPackages = (packages || []).map((pkg, i) => {
        const onPkgBookingClick = () => onBookingClick(pkg);
        const onPgkLearnMoreClick = () => setShowPackageModal(pkg);
        return <div className={`${componentClass}__service-package`} key={i}>
            <h2>{ pkg.title }</h2>
            <MarkupRender content={pkg.content} tagName="div" className="paragraph" />
            <div className="buttons">
                <button className="btn btn-secondary" onClick={onPkgBookingClick}>Book Now</button>
                <button className="btn btn-outline-secondary" onClick={onPgkLearnMoreClick}>Learn More</button>
            </div>
        </div>
    });

    return <React.Fragment>
        <PageHeader image={image_1} title={title} subtext={introText} type={1} addOnContent={
            <button className="btn btn-primary" onClick={() => onBookingClick()}>Book Now</button>
        }/>
        <section className={`page-section background-white page-section--padded`}>
            <div className="container text-left">
                <div className="paragraph"><MarkupRender content={content} /></div>
            </div>
        </section>
        <section className="page-section service-packages-section">
            <div className="container">
                <div className="service-packages-section__title">{ servicesTitle }</div>
                <div className="service-packages-section__subtitle">{ servicesSubtitle }</div>
                <div className="service-packages-section__items">{ renderedPackages }</div>
                <div className="service-packages-section__footer">{ servicesFooter }</div>
            </div>
        </section>
        <BookSessionModal
            onClose={onCloseClick}
            isOpen={showBookingModal}
            selectedType={selectedType}
            packageTypes={packages}
        />
        <Modal
            onClose={() => setShowPackageModal(false)}
            show={showPackageModal !== false}
            title={showPackageModal.title}
            className="packageInfoModal"
            closeBtn={<div className="btn btn-outline-secondary">Close</div>}
        >
            <MarkupRender className="paragraph" content={ showPackageModal.field_10 } />
        </Modal>
    </React.Fragment>
};

export default ServicesPage;
